import { SurveyData } from "./listingsSearchCriteriaApi";

export function asSurveyData(selectedOptions: any): SurveyData {
    const locations = selectedOptions.location_type === 'commute'
        ? (selectedOptions.commute_selected_areas || [])
        : selectedOptions.locations;
    return {
        locations,
        min_bedrooms: fromSlider(selectedOptions.bedrooms, 0),
        max_bedrooms: fromSlider(selectedOptions.bedrooms, 1),
        min_price: fromSlider(selectedOptions.prices, 0),
        max_price: fromSlider(selectedOptions.prices, 1),
        let_available_date: selectedOptions.let_available_date,
        furnish_types: selectedOptions.furnish_types,
        min_bathrooms: fromSlider(selectedOptions.bathrooms, 0),
        max_bathrooms: fromSlider(selectedOptions.bathrooms, 1),
        flat_size_min: selectedOptions.flat_size_min,
        deposit_max: fromSlider(selectedOptions.deposit_max),
        exclude_noisy_streets: selectedOptions.exclude_noisy_streets,
    };
}

export function fromSlider(slider: any, value?: number): number | undefined {
    if (!slider) return undefined;
    if (value !== undefined) return slider[value];
    return slider;
}
